import React, { Component } from 'react';
import ReactPlaceholder from 'react-placeholder';
import {
  InputPlaceholder
} from '@contently/toolkit';
import { get } from '../../../utils/shared/api';
import EnhancedSelect from './enhanced_select/enhanced_select';
import { handleError } from '../../utils/errors';
import tagsToGroups from './tagsToGroups';


class TagSelect extends Component {
  static mapTag(tag) {
    return {
      label: `${tag.name}`,
      value: tag.id,
      display: `${tag.name}`
    };
  }

  static mapTags = (groupName, tags) => tags.map(t => TagSelect.mapTag(t));

  static mapGroups = tagsResponse =>
    tagsResponse.map(g => ({
      label: g.name,
      options: TagSelect.mapTags(g.name, g.tags)
    }));

  constructor(props) {
    super(props);
    this.state = {
      availableTags: []
    };
  }

  componentDidMount() {
    const { brandProfileId, onFetching, onError } = this.props;
    onFetching('tags', true);
    return get(`/api/v1/brand_profiles/${brandProfileId}/tags`)
      .then(res => {
        onFetching('tags', false);
        this.setState({
          availableTags: TagSelect.mapGroups(tagsToGroups(res).groups)
        });
      })
      .catch(error => {
        handleError(error, () => onError());
      });
  }

  render() {
    const { availableTags } = this.state;
    const { fetching, values, touched, errors } = this.props;

    return (
      <ReactPlaceholder
        showLoadingAnimation
        customPlaceholder={<InputPlaceholder wrapperClass="row" withLabel />}
        ready={!fetching}
      >
        <EnhancedSelect
          {...this.props}
          selectedValue={values.tags}
          multi
          options={availableTags}
          errors={errors.tags}
          touched={touched.tags}
          noTranslate
        />
      </ReactPlaceholder>
    );
  }
}

export default TagSelect;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/tag-select.jsx